// extracted by mini-css-extract-plugin
export default {"container":"style_container__y59lk","title":"style_title__S26OM"};